import React from "react";
import './Companyrules.css';
const rule1 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742201500/91_wkbplh.png";
const rule2 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742201500/92_lzenid.png";
const rule3 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742201499/93_jfquxd.png";
const rule4 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742201500/94_ecxqds.png";

const Companyrules = () => {
    return (
        <>
            <div className="hmsection7">
                <h3 className="slider-title">OUR GUIDING PRINCIPLES</h3>
                <div className="hmsection7-2">
                    <p>For over 43 years, the Dasmesh Group has been building relationships and products that last. As a diversified Agricultural Machinery innovator and manufacturer, Dasmesh is recognized as one of the India's largest Combine Harvester Manufacturer.</p>
                    <p>Serving an impressive list of long-term customers, we are an organization of seasoned professionals & innovators with a tremendous breadth of agricultural experience and expertise across multiple regions and whether conditions.</p>
                </div>
                <div className="company-rules-main">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="company-rules-res-start">
                                <div className="company-rules-res-start-img"><img src={rule1} alt="rules" /></div>
                                <div className="company-rules-restrictions">
                                    <h3>Farmer Focused</h3>
                                    <p>We prioritize the happiness and satisfaction of farmers by continuously enhancing our machinery, developing new products, and providing exceptional after-sales service.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="company-rules-res-start">
                                <div className="company-rules-res-start-img"><img src={rule2} alt="rules" /></div>
                                <div className="company-rules-restrictions">
                                    <h3>Sustainable Approach</h3>
                                    <p>Dasmesh is committed to manufacturing world-class agricultural machinery with a focus on ecological balance and sustainability.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="company-rules-res-start">
                                <div className="company-rules-res-start-img"><img src={rule3} alt="rules" /></div>
                                <div className="company-rules-restrictions">
                                    <h3>Solution Centric</h3>
                                    <p>We transform farming practices by enhancing productivity and efficiency, helping farmers reduce costs and maximize profits.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="company-rules-res-start">
                                <div className="company-rules-res-start-img"><img src={rule4} alt="rules" /></div>
                                <div className="company-rules-restrictions">
                                    <h3>Integrity</h3>
                                    <p>We uphold our reputation by delivering top-quality products, ensuring strict quality checks at every production stage to meet international standards.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
};
export default Companyrules;